import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 4v2.6c-1.3 0-2.5-.3-3.6-.9v6.2c0 3.2-2.4 5.6-5.5 5.6S5.4 18.1 5.4 15c0-2.9 2.1-5.2 5-5.5v2.7c-1.3.2-2.3 1.3-2.3 2.8 0 1.6 1.2 2.8 2.7 2.8s2.7-1.2 2.7-3V3h3z" />
  </svg>
);

export default function Footer() {
  const [email, setEmail] = useState("");
  const [social, setSocial] = useState({ instagram: "", facebook: "", tiktok: "" });

  useEffect(() => {
    api.get("/settings").then(({ data }) => setSocial(data.social || {})).catch(() => {});
  }, []);

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch {
      toast.error("Nu am putut înregistra abonarea.");
    }
  };

  return (
    <footer className="bg-ink text-cream" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr_1fr_1.2fr] gap-12">
          <div>
            <h3 className="font-display text-4xl leading-tight">
              Coffee Cup <span className="text-sand">Supply</span>
            </h3>
            <p className="mt-4 text-cream/60 max-w-xs leading-relaxed">
              Cafea boabe prăjită din branduri de renume. Livrare națională, prospețime garantată.
            </p>
          </div>
          <div>
            <p className="overline text-sand mb-5">Navigare</p>
            <ul className="space-y-3 text-cream/70">
              <li><Link to="/produse" className="hover:text-sand transition-colors">Produse</Link></li>
              <li><Link to="/branduri" className="hover:text-sand transition-colors">Branduri</Link></li>
              <li><Link to="/despre-noi" className="hover:text-sand transition-colors">Despre noi</Link></li>
              <li><Link to="/contact" className="hover:text-sand transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-sand mb-5">Informații</p>
            <ul className="space-y-3 text-cream/70 text-sm" data-testid="footer-legal">
              <li><Link to="/termeni" className="hover:text-sand transition-colors">Termeni și condiții</Link></li>
              <li><Link to="/confidentialitate" className="hover:text-sand transition-colors">Confidențialitate</Link></li>
              <li><Link to="/cookies" className="hover:text-sand transition-colors">Politica de cookies</Link></li>
              <li><Link to="/livrare-plata" className="hover:text-sand transition-colors">Livrare și plată</Link></li>
              <li><Link to="/retur" className="hover:text-sand transition-colors">Politica de retur</Link></li>
              <li><Link to="/anpc" className="hover:text-sand transition-colors">ANPC</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-sand mb-5">Contact</p>
            <ul className="space-y-3 text-cream/70 text-sm">
              <li>office@coffeecup-supply.com</li>
              <li>0761 038 086</li>
              <li>Luni–Vineri, 09:00–18:00</li>
            </ul>
          </div>
          <div>
            <p className="overline text-sand mb-5">Newsletter</p>
            <p className="text-cream/60 text-sm mb-4">Oferte și noutăți despre cafea.</p>
            <form onSubmit={subscribe} className="flex border-b border-cream/25 pb-2">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Adresa ta de email"
                data-testid="newsletter-email"
                className="flex-1 bg-transparent outline-none text-sm placeholder:text-cream/40"
              />
              <button type="submit" data-testid="newsletter-submit" className="overline text-sand">
                Abonează-te
              </button>
            </form>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-cream/40 text-xs">© {new Date().getFullYear()} Coffee Cup Supply. Toate drepturile rezervate.</p>
          <div className="flex items-center gap-5 text-cream/60">
            <a href={social.instagram || "#"} target="_blank" rel="noopener noreferrer" data-testid="social-instagram" aria-label="Instagram" className="hover:text-sand transition-colors"><Instagram size={18} /></a>
            <a href={social.facebook || "#"} target="_blank" rel="noopener noreferrer" data-testid="social-facebook" aria-label="Facebook" className="hover:text-sand transition-colors"><Facebook size={18} /></a>
            <a href={social.tiktok || "#"} target="_blank" rel="noopener noreferrer" data-testid="social-tiktok" aria-label="TikTok" className="hover:text-sand transition-colors"><TikTokIcon size={18} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
